// The component is set up to handle different subscription 
// plans and dispatch corresponding actions based on user interactions.
import React from 'react';
import {  FaCheck } from 'react-icons/fa';
import {  useDispatch } from 'react-redux';
import { restartSubscription, } from '../../features/subscription/subscriptionSlice';


const PricingTable = () => {
    const dispatch = useDispatch();

    // function to dispatch the startProSub action, which starts a pro subscription
    const handleStartProSub = () => {
        dispatch(restartSubscription());
    };

    return (
        <>
            <div className="flex justify-center p-4">
                <div className="max-w-3xl w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Promo / info card */}
                    <div className="bg-ivory rounded-lg shadow-xl overflow-hidden border border-charcoal/10">
                        
                        <div className="px-6 py-6">
                            <div className="flex items-end gap-3">
                                <span className="text-5xl font-extrabold text-charcoal">$30</span>
                                <span className="text-sm text-charcoal/70">/mo · jobsite</span>
                            </div>

                            <button
                                type="button"
                                className="mt-6 w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-white font-semibold bg-gradient-to-r from-teal to-robin"
                                onClick={handleStartProSub}
                            >
                                Restart subscription
                            </button>

                            <div className="mt-6 text-charcoal text-sm">
                                <ul className="space-y-3">
                                    <li className="flex items-start gap-3">
                                        <FaCheck className="mt-1 text-orangem" />
                                        <span>Unlimited Jobsites</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <FaCheck className="mt-1 text-orangem" />
                                        <span>Message Board & Announcements</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <FaCheck className="mt-1 text-orangem" />
                                        <span>Unlimited Workers</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <FaCheck className="mt-1 text-orangem" />
                                        <span>Facial Recognition + Liveness Check</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Thank you message */}
                    <div className="bg-gradient-to-b from-sage to-ivory rounded-lg shadow-lg p-6 border border-charcoal/5 flex flex-col justify-between">
                        <div>
                            <h4 className="text-lg font-semibold text-charcoal">Thank you for trying TimeStat</h4>
                            <p className="text-sm text-charcoal/80 mt-2">
                                Your free trial has ended. To continue using facial recognition and other Pro features, please add a valid payment method to your account.
                            </p>
                        </div>

                        <div className="mt-6">
                            <p className="text-xs text-charcoal/70">
                                Add a payment method in Billing to keep using Pro features. Questions? Contact <a className="text-teal underline" href="mailto:support@timestat.app">support@timestat.app</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PricingTable;


